import React, { useEffect, useState } from 'react'
import { Container, Form, Tabs, Tab, Button, Row, Col } from 'react-bootstrap'
import { CATEGORIES_COLLECTION, GAMES_COLLECTION, serverTimestamp } from '../../firebase'
import { useParams } from 'react-router';
import { useHistory } from "react-router-dom";
import urlSlug from 'url-slug'
import moment from 'moment';

const INITIAL_STATE = {
    buy_one: '',
    buy_two: '',
    buy_three: '',
    category: [],
    date: serverTimestamp.now(),
    discount: '',
    iframe: '',
    image: '',
    poster: '',
    rating: '',
    release: '',
    rent_one: '',
    rent_two: '',
    slider: false,
    url: '',
    description_en: '',
    description_sr: '',
    details_en: '',
    details_sr: '',
    title_en: '',
    title_sr: '',
    specifications_and_requirements_en: '',
    specifications_and_requirements_sr: '',
    video: ''
}

const EditGame = () => {

    const { id } = useParams()

    const history = useHistory()

    const [edit, setEdit] = useState(INITIAL_STATE)

    const [categories, setCategories] = useState([])

    const handleEdit = async (e) => {

        e.preventDefault();

        await GAMES_COLLECTION.doc(id).update({
            _id: id,
            buy_one: edit.buy_one,
            buy_two: edit.buy_two,
            buy_three: edit.buy_three,
            category: edit.category,
            date: edit.date,
            discount: edit.discount,
            iframe: edit.iframe,
            image: edit.image,
            poster: edit.poster,
            rating: edit.rating,
            release: serverTimestamp.fromDate(new Date(edit.release)),
            rent_one: edit.rent_one,
            rent_two: edit.rent_two,
            slider: 'true' === edit.slider,
            url: urlSlug(edit.title_sr),
            description_en: edit.description_en,
            description_sr: edit.description_sr,
            details_en: edit.details_en,
            details_sr: edit.details_sr,
            title_en: edit.title_en,
            title_sr: edit.title_sr,
            specifications_and_requirements_en: edit.specifications_and_requirements_en,
            specifications_and_requirements_sr: edit.specifications_and_requirements_sr,
            video: edit.video
        })
            .then(() => {
                alert("Uspješno uređeno 👍")
                history.push('/')
            })
            .catch((error) => {
                alert(error.message)
            })
    }

    useEffect(() => {

        const getItems = async () => {
            const snapshot = await GAMES_COLLECTION.where('_id', '==', id).get()
            snapshot.forEach(doc => {
                setEdit(doc.data())
            })
        }

        getItems()

        const getCategories = async () => {
            const snapshot = await CATEGORIES_COLLECTION.get();
            const items = [];
            snapshot.forEach(doc => {
                items.push(doc.data())
            })
            setCategories(items)
        }

        getCategories()

    }, []);

    return (
        <>
            <Container>
                <Tabs defaultActiveKey="edit-game" className="mb-3" transition={false}>
                    <Tab eventKey="preview-game" title={<div onClick={() => history.push('/')}>Pregled igara</div>} />
                    <Tab eventKey="add-game" title={<div onClick={() => history.push('/add-game')}>Dodaj</div>} />
                    <Tab eventKey="edit-game" title="Uredi">
                        <Form onSubmit={handleEdit}>
                            <Row>
                                <Col lg={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Prodaja (Offline profil)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Unesite - Prodaja (Offline profil)"
                                            value={edit.buy_one}
                                            onChange={(e) => { setEdit({ ...edit, buy_one: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Prodaja (Primarni profil)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Unesite - Prodaja (Primarni profil)"
                                            value={edit.buy_two}
                                            onChange={(e) => { setEdit({ ...edit, buy_two: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Prodaja (Sekundarni profil)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Unesite - Prodaja (Sekundarni profil)"
                                            value={edit.buy_three}
                                            onChange={(e) => { setEdit({ ...edit, buy_three: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Kategorija</Form.Label>
                                        <Form.Control
                                            as="select"
                                            multiple={true}
                                            value={edit.category}
                                            onChange={(e) => { setEdit({ ...edit, category: [...e.target.selectedOptions].map(o => o.value) }) }}
                                            required
                                        >
                                            <option value="" disabled>Odaberite</option>
                                            {
                                                categories.map((item) =>
                                                    <option key={item._id} value={item.category}>
                                                        {item.title_sr}
                                                    </option>)
                                            }
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Popust</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Unesite - Popust"
                                            value={edit.discount}
                                            onChange={(e) => { setEdit({ ...edit, discount: e.target.value }) }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Media</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Unesite - Media"
                                            value={edit.iframe}
                                            onChange={(e) => { setEdit({ ...edit, iframe: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Slika</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Unesite - Slika"
                                            value={edit.image}
                                            onChange={(e) => { setEdit({ ...edit, image: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Poster (video)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Unesite - Poster (video)"
                                            value={edit.poster}
                                            onChange={(e) => { setEdit({ ...edit, poster: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Ocjena</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Unesite - Ocjena"
                                            value={edit.rating}
                                            onChange={(e) => { setEdit({ ...edit, rating: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Objavljeno</Form.Label>
                                        <Form.Control
                                            type="date"
                                            placeholder="Unesite - Objavljeno"
                                            value={edit.release}
                                            onChange={(e) => { setEdit({ ...edit, release: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Iznajmljivanje (8 dana)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Unesite - Iznajmljivanje (8 dana)"
                                            value={edit.rent_one}
                                            onChange={(e) => { setEdit({ ...edit, rent_one: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Iznajmljivanje (15 dana)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Unesite - Iznajmljivanje (8 dana)"
                                            value={edit.rent_two}
                                            onChange={(e) => { setEdit({ ...edit, rent_two: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Istaknuto (slider)</Form.Label>
                                        <Form.Control
                                            as="select"
                                            value={edit.slider}
                                            onChange={(e) => { setEdit({ ...edit, slider: e.target.value }) }}
                                            required
                                        >
                                            <option value="" disabled>Odaberite</option>
                                            <option value='false'>Ne</option>
                                            <option value='true'>Da</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Opis (EN)</Form.Label>
                                        <Form.Control
                                            rows={5}
                                            as="textarea"
                                            placeholder="Unesite - Opis (EN)"
                                            value={edit.description_en}
                                            onChange={(e) => { setEdit({ ...edit, description_en: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Opis (SR)</Form.Label>
                                        <Form.Control
                                            rows={5}
                                            as="textarea"
                                            placeholder="Unesite - Opis (SR)"
                                            value={edit.description_sr}
                                            onChange={(e) => { setEdit({ ...edit, description_sr: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Detalji (EN)</Form.Label>
                                        <Form.Control
                                            rows={5}
                                            as="textarea"
                                            placeholder="Unesite - Detalji (EN)"
                                            value={edit.details_en}
                                            onChange={(e) => { setEdit({ ...edit, details_en: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Detalji (SR)</Form.Label>
                                        <Form.Control
                                            rows={5}
                                            as="textarea"
                                            placeholder="Unesite - Detalji (SR)"
                                            value={edit.details_sr}
                                            onChange={(e) => { setEdit({ ...edit, details_sr: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Naslov (EN)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Unesite - Naslov (EN)"
                                            value={edit.title_en}
                                            onChange={(e) => { setEdit({ ...edit, title_en: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Naslov (SR)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Unesite - Naslov (SR)"
                                            value={edit.title_sr}
                                            onChange={(e) => { setEdit({ ...edit, title_sr: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Specifikacije i zahtjevi (EN)</Form.Label>
                                        <Form.Control
                                            rows={5}
                                            as="textarea"
                                            placeholder="Unesite - Specifikacije i zahtjevi (EN)"
                                            value={edit.specifications_and_requirements_en}
                                            onChange={(e) => { setEdit({ ...edit, specifications_and_requirements_en: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Specifikacije i zahtjevi (SR)</Form.Label>
                                        <Form.Control
                                            rows={5}
                                            as="textarea"
                                            placeholder="Unesite - Specifikacije i zahtjevi (SR)"
                                            value={edit.specifications_and_requirements_sr}
                                            onChange={(e) => { setEdit({ ...edit, specifications_and_requirements_sr: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Video</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Unesite - Video"
                                            value={edit.video}
                                            onChange={(e) => { setEdit({ ...edit, video: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Button variant="primary" type="submit">
                                        Uredi
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Tab>
                    <Tab eventKey="delete-game" title='Obriši' disabled />
                </Tabs>
            </Container>
        </>
    )
}

export default EditGame
